module.exports = __webpack_public_path__ + "static/profile-placeholder.94d390bc.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/public/images/profile-placeholder.png
// module id = 151
// module chunks = 1